<template>
  <div class="news_wrap">
    <div class="news_tit">新闻资讯</div>
    <div class="news_detail">
      <div class="news_item hvr-curl-top-right" v-for="(item, index) in newsList" :key="index">
        <div class="news_item_util">
          <div class="news_plate_wrap" style="position: relative;">
            <div class="news_plate">
              {{ item.type?.typeName }}
              <span class="plate_arrow" @click="$router.push('/fournav/' + item.type?.id)">></span>
            </div>
          </div>
          <div class="bottom_wrap" @click="handleToNewsDetails(item.id)">
            <div class="bottom_left">
              <img :src="item.image" alt="" />
            </div>
            <div class="bottom_right">
              <div class="right_title">{{ item.title }}</div>
              <div class="right_desc">{{ item.author }}</div>
              <router-link class="hidden-xs-only right_btn" to="/fournav/3">更多 >></router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsHomeRecommend } from '../../api/news'

export default {
  data() {
    return {
      newsList: [],
    }
  },
  methods: {
    handleToNewsDetails(id) {
      this.$router.push('/news_detail/' + id)
    },
    async getNewsHomeRecommendFunc() {
      const res = await getNewsHomeRecommend()
      if (res.data) {
        this.newsList = res.data.data;
      }
    }
  },
  mounted() {
    this.getNewsHomeRecommendFunc()
  }
}
</script>

<style lang="scss" scoped>
.news_wrap {
  width: 100%;
  margin-top: 50px;
  text-align: center;

  .news_tit {
    color: #203040;
    font-size: 40px;
    font-weight: bold;

    @media screen and (max-width: 768px) {
      font-size: 1.8rem;
      padding: 0 10px;
      margin-top: 20px;
      line-height: 1.4;
    }
  }

  .news_detail {
    width: 70%;
    margin-top: 40px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    @media screen and (max-width: 768px) {
      width: 95%;
      margin-top: 0px;
      gap: 15px;
    }

    .news_item {
      display: flex;
      width: 47%;
      margin-top: 30px;

      @media screen and (max-width: 768px) {
        width: 100%;
        margin-top: 0;
        padding: 10px;
        box-sizing: border-box;
      }

      .news_item_util {
        width: 100%;

        .news_plate_wrap {
          width: 100%;

          .news_plate {
            color: #717171;
            font-weight: bold;
            text-align: left;
            margin: 20px 0;
            font-size: 22px;
            pointer-events: none;
            cursor: default;
            padding-right: 25px;

            @media screen and (max-width: 768px) {
              font-size: 1.5rem;
              pointer-events: auto;
              margin: 10px 0 5px;
            }

            .plate_arrow {
              display: none;
              position: absolute;
              top: 50%;
              right: 5px;
              transform: translateY(-50%);
              font-size: 1rem;
              color: #717171;
              font-weight: bold;
              cursor: pointer;

              @media screen and (max-width: 768px) {
                width: 10%;
                text-align: center;
                display: block;
              }
            }
          }
        }

        .bottom_wrap {
          display: flex;
          width: 100%;

          @media screen and (max-width: 768px) {
            flex-direction: column;
            cursor: pointer;
          }

          .bottom_left {
            flex-shrink: 0;

            img {
              width: 300px;
              height: 160px;
              object-fit: cover;

              @media screen and (max-width: 768px) {
                width: 100%;
                height: 200px;
                margin: 0;
                border-radius: 8px;
              }
            }
          }

          .bottom_right {
            margin-left: 10px;
            text-align: left;
            flex: 1;

            @media screen and (max-width: 768px) {
              margin-left: 0;
              margin-top: 10px;
              padding: 0 5px;
            }

            .right_title {
              font-weight: bold;
              font-size: 18px;
              overflow: hidden;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              line-height: 1.5;
              height: 3em;              

              @media screen and (max-width: 768px) {
                font-size: 1.1rem;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                line-height: 1.4;
                margin-bottom: 5px;
              }
            }

            .right_desc {
              color: #717171;
              font-size: 15px;
              margin-top: 15px;
              line-height: 20PX;

              @media screen and (max-width: 768px) {
                font-size: 0.9rem;
                min-height: auto;
                margin-top: 5px;
                line-height: 1.6;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
              }
            }

            .right_btn {
              float: left;
              background: #ffa400;
              height: 15%;
              font-size: 14px;
              padding: 0 10px;
              color: #fff;
              border-radius: 15px;
              display: flex;
              justify-content: center;
              align-items: center;
              margin-top: 15px;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>